/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_21c475d4{position:relative;padding:10px 84px;cursor:pointer}.root_21c475d4 .ms-Link{font-size:12px}\n"}]);
export const root = "root_21c475d4";